import { Injectable } from "@angular/core";
import { UserCycleApi } from "src/app/api/user-cycle.api";

@Injectable()
export class UserCycleService {

    constructor(
        private userCycleApi: UserCycleApi
    ) {}

    getUserCycleDetails = (userCycleId: string) => this.userCycleApi.getUserCycleDetails(userCycleId);
}